// "Modeli kaydet" formunun taslağı eğitim işi (job id) bazında tarayıcıda saklanır: kullanıcı sayfadan çıkıp bildirimle
// ya da "Son eğitimlerim" listesinden döndüğünde ad, açıklama ve uygulama SQL'i geri gelir; kaydedilen model adı da tutulur.
const STORAGE_KEY = 'mlFpSaveDrafts';
const MAX_DRAFTS = 30;

function readAll() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    const parsed = raw ? JSON.parse(raw) : {};
    return parsed && typeof parsed === 'object' ? parsed : {};
  } catch (error) {
    console.error('fpReductionDrafts.readAll', error);
    return {};
  }
}

export function readSaveDraft(jobId) {
  if (!jobId) {
    return null;
  }
  return readAll()[jobId] || null;
}

// En son güncellenen MAX_DRAFTS iş tutulur; eskiler silinir.
export function writeSaveDraft(jobId, draft) {
  if (!jobId) {
    return;
  }
  const drafts = readAll();
  drafts[jobId] = { ...drafts[jobId], ...draft, updatedAt: Date.now() };
  const kept = {};
  Object.keys(drafts)
    .sort((a, b) => (drafts[b].updatedAt || 0) - (drafts[a].updatedAt || 0))
    .slice(0, MAX_DRAFTS)
    .forEach(key => {
      kept[key] = drafts[key];
    });
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(kept));
  } catch (error) {
    console.error('fpReductionDrafts.writeSaveDraft', error);
  }
}
